import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { TwoFactorChallenge } from "@/components/two-factor-challenge";
import { supabase } from "@/integrations/supabase/client";

function sanitize(url: string): string {
  if (!url || url === "/mfa-challenge") return "/";
  if (!url.startsWith("/")) return "/";
  return url;
}

export const Route = createFileRoute("/mfa-challenge")({
  validateSearch: (s: Record<string, unknown>) => ({ redirect: (s.redirect as string) || "/" }),
  head: () => ({
    meta: [
      { title: "Two-factor verification — Pluggz" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: MfaChallengePage,
});

function MfaChallengePage() {
  const navigate = useNavigate();
  const search = useSearch({ from: "/mfa-challenge" });

  return (
    <div className="relative mx-auto w-full max-w-md px-4 py-12 sm:px-6 sm:py-20">
      <p className="editorial-eyebrow">Verification required</p>
      <h1 className="mt-2 font-serif text-3xl sm:text-4xl">
        Two-factor <span className="italic">authentication</span>
      </h1>
      <p className="mt-3 text-sm text-muted-foreground">
        Enter the 6-digit code from your authenticator app to continue.
      </p>
      <div className="mt-8">
        <TwoFactorChallenge
          onVerified={() => navigate({ to: sanitize(search.redirect) })}
          onCancel={async () => {
            await supabase.auth.signOut();
            navigate({ to: "/login" });
          }}
        />
      </div>
    </div>
  );
}